import * as moment from 'moment';
import EventBus from '@/helpers/event-bus';
import SubmissionService, { groupeSectorSubmissions } from '@/services/Submission/SubmissionService';
import { setStoreValue } from '@/store/modules/storeHelpers';


const state = {
    data: [],
    default: {
        company_id: null,
        country_code: '',
        composition_id: null,
        collection_date: null,
        volume_gross: null,
        volume_net: null,
        comments: '',
        volume_units: '%',
    },
    current: {
        company_id: null,
        country_code: '',
        composition_id: null,
        collection_date: null,
        volume_gross: null,
        volume_net: null,
        comments: '',
        volume_units: '%',
    },
    currentSubmissionsPage: 1,
    sectorSubmissions: [],
};

const actions = {
    getSubmissions({ commit }, companyId = false) {
        return SubmissionService.getSubmissions(companyId).then(result => {
            commit('setData', result.data);
        });
    },
    getUserSectorSubmissions({ commit }) {
        return SubmissionService.getSectorSubmissions().then(result => {
            commit('setStoreValue', { key: 'sectorSubmissions', value: result.data });
        });
    },
    save(_, submissionData) {
        return SubmissionService.createSubmission(submissionData).then(() => { });
    },
    current({ commit }, data) {
        commit('current', data);
    },
    addOther({ commit }) {
        commit('addOther');
    },
    async remove({ commit }, id) {
        try {
            const response = await SubmissionService.removeSubmission(id);
            const { data } = response;

            if (data && data.status === 1) {
                EventBus.$emit('snotifySuccess', 'Remove submission success.');
                commit('removeSubmission', id);
            }
        } catch (error) {
            if (error.response.data.errors.length) {
                EventBus.$emit('snotifyError', error.response.data.errors[0].msg);
            } else {
                EventBus.$emit('snotifyError', 'Remove submission error.');
            }
        }
    },
    async approve({ commit, dispatch }, id) {
        try {
            const response = await SubmissionService.approveSubmission(id);
            const { data } = response;

            if (data && data.status === 1) {
                EventBus.$emit('snotifySuccess', 'Submission approved.');
                commit('approveSubmission', id);
                dispatch('getSubmissions');
            }
        } catch (error) {
            EventBus.$emit('snotifyError', 'Approve submission error.');
        }
    },
    async update(_, updateData) {
        const { submission_id } = updateData;

        try {
            const response = await SubmissionService.updateSubmission(submission_id, updateData);
            const { data } = response;

            if (data && data.status === 1) {
                EventBus.$emit('snotifySuccess', 'Submission updated.');
            }
        } catch (error) {
            if (error.response.data.errors.length) {
                EventBus.$emit('snotifyError', error.response.data.errors[0].msg);
            } else {
                EventBus.$emit('snotifyError', 'Submission updated error.');
            }
        }
    }
};

const mutations = {
    setStoreValue,
    setData(state, data) {
        state.data = data;
    },
    current(state, data) {
        state.current = data;
    },
    approveSubmission(state, id) {
        const submission = state.data.find(submission => submission.id !== id);
        submission.accepted_date = moment().format('YYYY-MM-DD');

        const user = JSON.parse(localStorage.getItem('user'));
        submission.accepted_by = user.name;
    },
    removeSubmission(state, id) {
        const decrementedSubmissions = state.data.filter(submission => submission.id !== id);
        state.data = decrementedSubmissions;
    },
    setCurrentSubmissionsPage(state, currentSubmissionsPage) {
        state.currentSubmissionsPage = currentSubmissionsPage;
    }
};

const getters = {
    data(state) {
        return state.data;
    },
    current(state) {
        return state.current;
    },
    default(state) {
        return state.default;
    },
    groupedSectorSubmissions(state) {
        return groupeSectorSubmissions(state.sectorSubmissions);
    }

};

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true,
};
